import { useEffect } from 'react'
import { matchRoutes, useLocation } from 'react-router-dom'

import { routes } from '~/constants.ts'

import { trackPageview } from './plausible.ts'

const routeObjects = routes.map((route) => ({ path: route }))

export function TrackPageView() {
  const location = useLocation()

  useEffect(() => {
    const matches = matchRoutes(routeObjects, location)

    // Don’t track locations with the authKey query parameter, such as the reset-password page.
    if (location.search.includes('authKey')) {
      return
    }

    // track the route as is if we don't have a match
    if (!matches) {
      return trackPageview()
    }

    // track the parameterized path (eg. /c/:workspace) if we have a match
    const match = matches[matches.length - 1]
    return trackPageview({
      url: window.location.origin + match.route.path,
    })
  }, [location])

  return null
}
